import LinkV2, { LinkV2Props } from '@zola/zola-ui/src/components/LinkV2/LinkV2';

import { VENDOR_SUPPORT_EMAIL } from '~/util/vendorSupportEmail';

export const VendorSupportEmail: React.FC<LinkV2Props> = (props): JSX.Element => {
  const { children = VENDOR_SUPPORT_EMAIL, ...rest } = props;
  return (
    // @ts-expect-error TypeScript is confused and thinks the href should be undefined
    <LinkV2 href={`mailto:${VENDOR_SUPPORT_EMAIL}`} noTextTransform {...rest}>
      {children}
    </LinkV2>
  );
};

export default VendorSupportEmail;
